import getCookieValue from 'util/getCookie';
import { USER_ID_COOKIE_NAME } from './constants';

export let userId: string | undefined = getCookieValue(USER_ID_COOKIE_NAME);
export const setUserId = (id?: string) => {
  userId = id;
};
